export const INPUT_FOCUS = 'header/INPUT_FOCUS';
export const INPUT_BLUR = 'header/INPUT_BLUR';
export const BUSINESS_CENTER_CLICK = 'businesscenter/BUSINESS_CENTER_CLICK';
export const BUSINESS_MSG_CLICK = 'businesscenter/BUSINESS_MSG_CLICK';
export const SECURITY_SETTING_CLICK = 'businesscenter/SECURITY_SETTING_CLICK';
//export const VIP_CLICK='businesscenter/VIP_CLICK';
export const HOME_SEARCH = 'header/HOME_SEARCH'
export const SET_USER_INFO = 'header/SET_USER_INFO'